import React, { useEffect,useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import RoomDatatables from "component/master/room/RoomDatatables";
import RoomModalForm from "component/master/room/RoomModalForm";

function Room() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [room, setRoom] = useState([]);

  const fetchRoom = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/room`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data room");
  
      const data = await response.json();
      setRoom(data.data);
    } catch (error) {
      console.error("Error fetching category:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Room";
      window.scrollTo(0, 0);
      fetchRoom();
  }, []);

  const handleAddRoom = () => {
    setModalMode("add");
    setSelectedRoom(null);
    setIsModalOpen(true);
  }

  const handleEditRoom = (room) => {
    setModalMode("edit");
    setSelectedRoom(room);
    setIsModalOpen(true);
  }

  const handleDeleteRoom = async (room) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Room',
        text: `Apakah Anda yakin ingin menghapus Room ${room.room_number}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      if (!room?.room_id) {
        alert("Room ID tidak ditemukan");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API}/room/${room.room_id}`
      );

  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Room berhasil dihapus");
        fetchRoom();
      } else {
        showError(response.data.message || "Gagal menghapus Room");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Room");
    }
  };  

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Room Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddRoom}>
                              </i>
                            </div>
                            <RoomDatatables data={room} onEditRoom={handleEditRoom} onDeleteRoom={handleDeleteRoom}/>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <RoomModalForm mode={modalMode} roomData={selectedRoom} closeModal={closeModal}  onSuccess={fetchRoom}/>
        </div>
      )}

    </div>
  );
}

export default Room;
